import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { CardBody } from "../../../_metronic/_partials/controls";
import { postProduct } from "../../../api/product";
import {
	calculateMinutesFromTime,
	formatInstallationTime,
} from "../../../utils/helpers";
import { alertError, alertSuccess } from "../../../utils/logger";

function getEmptyProduct() {
	return {
		referencia: null,
		descripcion: null,
		familia_id: null,
		tipo_producto_id: null,
		precio: null,
		tipo_unidad_id: null,
		tiempo_instalacion: null,
		descuento_base: null,
	};
}

const CreateProductDialog = (props) => {
	const {
		title,
		open,
		setOpen,
		productFamilies,
		productTypes,
		productUnitTypes,
		onSave,
	} = props;

	const [product, setProduct] = useState(getEmptyProduct());

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function saveProduct() {
		const validateProduct = () => {
			let error = "";

			if (!product?.descripcion) {
				error = "La descripción es obligatoria.";
			} else if (!product?.referencia) {
				error = "La referencia es obligatoria.";
			} else if (!product?.familia_id) {
				error = "La familia es obligatoria.";
			} else if (!product?.tipo_producto_id) {
				error = "El tipo de producto es obligatorio.";
			} else if (!product?.tipo_unidad_id) {
				error = "El tipo de unidad es obligatorio.";
			} else if (!product?.precio) {
				error = "El precio es obligatorio.";
			} else if (!product?.tiempo_instalacion) {
				error = "El tiempo de instalación es obligatorio.";
			}

			if (error) {
				alertError({
					error: error,
				});
				return false;
			}

			return true;
		};

		if (!validateProduct()) {
			return;
		}

		postProduct(product, loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 201) {
					alertSuccess({
						title: "¡Guardado!",
						customMessage: "Producto guardado con éxito.",
					});
					onSave(res.data?.id);
					setOpen(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se ha podido guardar el producto.",
				});
			});
	}

	const handleChange = (element) => (event) => {
		let value = event.target.value;
		if (element === "tiempo_instalacion")
			value = calculateMinutesFromTime(value);

		setProduct({ ...product, [element]: value });
	};

	return (
		<>
			<Dialog
				fullWidth={true}
				maxWidth="md"
				open={open}
				onClose={() => {
					setOpen(false);
				}}
				aria-labelledby="table-dialog"
				className="backdrop"
			>
				<DialogTitle id="table-dialog">{title}</DialogTitle>
				<DialogContent>
					<CardBody className="pt-0 px-0">
						<div className="row d-flex align-items-center">
							<div className="col-md-6">
								<TextField
									id={`descripcion`}
									label="Descripción"
									value={product.descripcion}
									onChange={handleChange("descripcion")}
									InputLabelProps={{
										shrink: true,
									}}
									margin="normal"
									variant="outlined"
									required
								/>
							</div>
							<div className="col-md-6">
								<TextField
									id={`referencia`}
									label="Referencia"
									value={product.referencia}
									onChange={handleChange("referencia")}
									InputLabelProps={{
										shrink: true,
									}}
									margin="normal"
									variant="outlined"
									required
								/>
							</div>
						</div>
						<div className="row d-flex align-items-center">
							<div className="col-md-4">
								<Autocomplete
									id="autocomplete-familia"
									disablePortal
									disableClearable
									filterSelectedOptions
									options={productFamilies}
									getOptionLabel={(option) =>
										option.descripcion
									}
									value={
										productFamilies?.find(
											(x) => x.id === product?.familia_id
										) || ""
									}
									onChange={(event, selected) => {
										setProduct({
											...product,
											familia_id: selected
												? selected.id
												: null,
										});
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											label="Familia"
											margin="normal"
											variant="outlined"
											InputLabelProps={{
												shrink: true,
											}}
											required
										/>
									)}
								/>
							</div>
							<div className="col-md-4">
								<Autocomplete
									id="autocomplete-tipo"
									disablePortal
									disableClearable
									filterSelectedOptions
									options={productTypes}
									getOptionLabel={(option) =>
										option.descripcion
									}
									value={
										productTypes?.find(
											(x) =>
												x.id ===
												product?.tipo_producto_id
										) || ""
									}
									onChange={(event, selected) => {
										setProduct({
											...product,
											tipo_producto_id: selected
												? selected.id
												: null,
										});
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											label="Tipo de Producto"
											margin="normal"
											variant="outlined"
											InputLabelProps={{
												shrink: true,
											}}
											required
										/>
									)}
								/>
							</div>
							<div className="col-md-4">
								<Autocomplete
									id="autocomplete-tipo-unidad"
									disablePortal
									disableClearable
									filterSelectedOptions
									options={productUnitTypes}
									getOptionLabel={(option) =>
										option.descripcion
									}
									value={
										productUnitTypes?.find(
											(x) =>
												x.id === product?.tipo_unidad_id
										) || ""
									}
									onChange={(event, selected) => {
										setProduct({
											...product,
											tipo_unidad_id: selected
												? selected.id
												: null,
										});
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											label="Tipo de Unidad"
											margin="normal"
											variant="outlined"
											InputLabelProps={{
												shrink: true,
											}}
											required
										/>
									)}
								/>
							</div>
						</div>
						<div className="row d-flex align-items-center">
							<div className="col-md-4">
								<TextField
									id={`precio`}
									label="Precio (€)"
									value={product.precio}
									onChange={handleChange("precio")}
									InputLabelProps={{
										shrink: true,
									}}
									InputProps={{
										inputProps: {
											min: 0,
										},
									}}
									type="number"
									margin="normal"
									variant="outlined"
									required
								/>
							</div>
							<div className="col-md-4">
								<TextField
									id={`tiempo_instalacion`}
									label="Tiempo de instalación"
									value={formatInstallationTime(
										product.tiempo_instalacion
									)}
									onChange={handleChange(
										"tiempo_instalacion"
									)}
									InputLabelProps={{
										shrink: true,
									}}
									InputProps={{
										inputProps: {
											min: 0,
										},
									}}
									type="time"
									margin="normal"
									variant="outlined"
									required
								/>
							</div>
							<div className="col-md-4">
								<TextField
									id={`descuento`}
									label="Descuento base"
									value={product.descuento_base}
									onChange={handleChange("descuento_base")}
									InputLabelProps={{
										shrink: true,
									}}
									InputProps={{
										inputProps: {
											min: 0,
										},
									}}
									type="number"
									margin="normal"
									variant="outlined"
								/>
							</div>
						</div>
					</CardBody>
				</DialogContent>
				<DialogActions>
					<Button
						className="mr-2"
						onClick={() => {
							setOpen(false);
							setProduct(getEmptyProduct());
						}}
						variant="outlined"
					>
						Cancelar
					</Button>
					<Button
						onClick={() => {
							saveProduct();
						}}
						variant="outlined"
						color="primary"
					>
						Guardar
					</Button>
					<br />
				</DialogActions>
			</Dialog>
		</>
	);
};
export default CreateProductDialog;
